import { SortOrder } from './sort-direction';

export class ForwardOnlySearchResult<T> {
  limit: number;
  continuationToken: string;
  sortByFieldName: string;
  sortDirection: SortOrder;
  results: T[];
}
